<template>
    <div class="content_module">
            <div class='content'>
                <p v-if="customer_pain_point.title" class='title1'>{{customer_pain_point.title}}</p>
                <p v-if="customer_pain_point.title" class='title2'>{{customer_pain_point.value}}</p>
                <p v-if="customer_pain_point.title" class='title3'><span></span></p>

                <div class="pain_point">
                    <img width="100%" src="/static/image/product_center/draco_db/pain_point1.png">
                    <ul>
                        <li v-for="item,key in customer_pain_point.items">
                            <p :ref="'P'+key" :class="{leftTop:item.position=='leftTop','rightTop':item.position=='rightTop','leftBottom':item.position=='leftBottom','rightBottom':item.position=='rightBottom'}" :style="{backgroundImage:item.img_src}" v-html="item.mes"></p>
                        </li>
                    </ul>
                </div>
            </div>
    </div>
</template>

<script>
export default {
  name: 'customer-pain-point',
  props:["customer_pain_point"],
  data () {
    return {
    }
  },
  created:function(){
    let self = this;
  },
  mounted () {
    let self = this
    let rightReveal=self.$root.$data.rightReveal
    let leftReveal=self.$root.$data.leftReveal
    let topReveal=self.$root.$data.topReveal
    let fooReveal=self.$root.$data.fooReveal
    let fadeReveal=self.$root.$data.fadeReveal
    self.$scroll().reveal(self.$refs.P0,{...leftReveal,delay:200})
    self.$scroll().reveal(self.$refs.P1,{...rightReveal,delay:700})
    self.$scroll().reveal(self.$refs.P2,{...leftReveal,delay:200})
    self.$scroll().reveal(self.$refs.P3,{...rightReveal,delay:700})
  },
}
</script>

<style scoped>
@import '../../../../static/css/common.css';

.content_module{
    position:relative;
    background-color:#f9fafc;
}

.content_module .back{
    position:absolute;
    z-index:0;
    width:100%;
    top:auto;
    height:1em;
    text-align:center;
    font-size:360px;
    overflow:hidden;
    margin:0 auto;
    bottom:250px;
    color:rgba(245,248,255,0.4);
}

.content_module .content{
    margin:30px auto;
    margin-top:0;
    position:relative;
    display:flex;
    justify-content:center;
    flex-wrap:wrap;
}

.pain_point{
    width:100%;
    background-image:url(/static/image/product_center/draco_db/pain_point.png);
    background-size:300px auto;
    background-repeat:no-repeat;
    background-position:center center;
}
.pain_point img{
    display:none;
}

ul{
    width:100%;
    display:flex;
    justify-content:space-between;
    flex-wrap:wrap;
    margin-top:30px;
}

li{
    list-style:none;
    width:50%;
}

.content_module .content li p{
    width:400px;
    height:154px;
    background-size:100% 100%;
    font-size:16px;
    color:#fff;
    line-height:30px;
    text-align:justify;
}
.content_module .content li .leftTop{
    padding:42px 225px 50px 16px;
    float:right;
    margin-right:53px;
    margin-top:20px;
}
.content_module .content li .rightTop{
    padding:42px 36px 50px 205px;
    margin-top:20px;
    float:left;
    margin-left:51px;
    margin-right:18px;
}
.content_module .content li .leftBottom{
    padding:60px 225px 42px 16px;
    float:right;
    margin-right:37px;
    width:412px;
    height:174px;
    margin-top:7px;
}
.content_module .content li .rightBottom{
    padding:72px 16px 50px 245px;
    float:left;
    margin-left:10px;
    width:440px;
    height:183px;
}
</style>
<style scoped>
@media screen and (max-width: 920px) {

.pain_point{
    width:100%;
    background:none;
}
.pain_point img{
    display:block;
    margin:20px 0;
}
.content_module .content ul{
    display:none !important;
}

}
</style>



// WEBPACK FOOTER //
// src/components/common/product_center/customer_pain_point.vue